
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./NPCGenerator": () => {
return Promise.all(/*  | __federation_expose_NPCGenerator */ [__webpack_require__.e("115"), __webpack_require__.e("869")]).then(() => (() => (__webpack_require__(57))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };